import { Box } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import { useComponentParams } from 'components/SalaryComponents/hooks';
import { WizardError, WizardHeader, WizardWrapper } from 'components/WizardViews/components';
import WizardPathToStepController from 'components/WizardViews/components/WizardPathToStepController';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { editNonPayableBenefitsRouteToStepMap } from '../constants';
import GeneralDetailsStep from './GeneralDetailsStep';

const EditNonPayableBenefitsForm = () => {
  const { componentId } = useComponentParams();

  const history = useHistory();
  // No need for initialization state since we're using initialState prop

  // Commented out API usage for now
  /*
  const { isFetching, refetch, error } = useQuery({
    queryKey: [salaryComponentsQueries.getSalaryComponentById, componentId],
    queryFn: () =>
      api.salaryComponents.queries.getSalaryComponent({
        id: componentId!,
        category: 'NON_PAYABLE_BENEFITS_CATEGORY',
      }),
    enabled: isExistingComponent,
    onSuccess(data) {
      const formData = convertSalaryComponentToNonPayableBenefitsFormData(
        data.payrollGetSalaryComponent.data.salaryComponent as NonPayableBenefitsComponentType,
      );
      setFormData(formData);
    },
  });
  */

  // Redirect to list view if no component ID is present
  if (!componentId) {
    return <Redirect to={routePaths.salaryComponents.root} />;
  }

  const handleCloseClick = () => history.push(routePaths.salaryComponents.root);

  return (
    <WizardInfoProvider initialStep={0} totalSteps={1}>
      <WizardPathToStepController routeStepMap={editNonPayableBenefitsRouteToStepMap} />
      <WizardWrapper>
        <WizardHeader
          heading="Edit"
          subHeading="Non-Payable Benefit Component"
          onCloseClick={handleCloseClick}
        />
        <Box flex={1} overflowY="auto" height="100%">
          <WizardError onRetry={() => {}} error={null}>
            <GeneralDetailsStep />
          </WizardError>
        </Box>
      </WizardWrapper>
    </WizardInfoProvider>
  );
};

export default EditNonPayableBenefitsForm;
